const NEW_HAMPSHIRE = 'NH';
const statesIneligibleForCard = [NEW_HAMPSHIRE];
export default statesIneligibleForCard;
